import Model from '@/models/Model'

export default class PosPendingSale extends Model {
  resource() {
    return 'pos_pending_sale'
  }
}